import widgetBorder from './border/index.js';

export const constants = {
  labelWidth: '80px',
}

export const widgetPackage = {

  widgetTitle: require('./title/index.js').default,
  widgetBanner: require('./banner/index.js').default,

  widgetBorder: widgetBorder,
  widgetActiveRing: require('./activeRing/index.js').default,
  widgetScrollTable: require('./scrollTable/index.js').default,
  widgetEchartsBar: require('./echartsBar/index.js').default,

}
export default {widgetPackage, constants}
